import { render, staticRenderFns } from "./productModelOperationFee.vue?vue&type=template&id=48827870&scoped=true"
import script from "./productModelOperationFee.vue?vue&type=script&lang=js"
export * from "./productModelOperationFee.vue?vue&type=script&lang=js"
import style0 from "./productModelOperationFee.vue?vue&type=style&index=0&id=48827870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48827870",
  null
  
)

export default component.exports